import { useEffect, useState } from "react"

function formatCountdown(msRemaining: number): string {
  const totalSeconds = Math.floor(msRemaining / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  const pad = (n: number) => n.toString().padStart(2, "0")
  return `${pad(minutes)}:${pad(seconds)}`
}

// Ticking "expires in MM:SS" for an upgrade-checkout trade-in lock — always
// rendered next to a Locked badge (the license page and the Library's
// entitlement cards), which is what "expires" refers to; disappears by
// itself when the lock runs out. Normal weight and an own left margin, since
// it sits inside bold headers right after the badge.
export default function LockCountdown({ lockedUntil }: { lockedUntil: string }) {
  const target = new Date(lockedUntil).getTime()
  const [remaining, setRemaining] = useState(() => target - Date.now())

  useEffect(() => {
    const tick = () => setRemaining(target - Date.now())
    tick()
    const interval = setInterval(tick, 1000)
    return () => clearInterval(interval)
  }, [target])

  if (remaining <= 0) return null

  return (
    <span style={{ color: "var(--nfa-orange)", fontSize: "10pt", fontWeight: "normal", whiteSpace: "nowrap", marginLeft: 8 }}>
      expires in {formatCountdown(remaining)}
    </span>
  )
}
